import { getApiMfaGetmfacredentials } from "./getApiMfaGetmfacredentials";
import { postApiMfaSelectcredential } from "./postApiMfaSelectcredential";
import { postApiMfaValidatecode } from "./postApiMfaValidatecode";
import { postApiMfaValidatemfa } from "./postApiMfaValidatemfa";

export function MFAController() {
  return {
    postApiMfaValidatemfa,
    getApiMfaGetmfacredentials,
    postApiMfaSelectcredential,
    postApiMfaValidatecode,
  };
}
